import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const wrapperStyles = ({ theme }) => css`
  display: grid;
  gap: 8px;
  grid-template-columns: 1fr;
  justify-content: center;

  @media (min-width: ${theme.breakpoints.sm}) {
    grid-template-columns: auto 1fr;
    align-items: center;
  }
`

export const Wrapper = styled.div(wrapperStyles)

export const blocksStyles = ({ theme }) => css`
  display: flex;
  gap: 4px;
  justify-content: center;

  @media (min-width: ${theme.breakpoints.sm}) {
    justify-content: flex-start;
  }
`
export const Blocks = styled.div(blocksStyles)

export const blockStyles = () => css`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 4px 8px;
  text-align: center;
  border: 1px solid #000;
  border-radius: 4px;
  min-width: 55px;
  background: rgba(255, 255, 255, 0.2);
`

export const Block = styled.div(blockStyles)

export const numberStyles = () => css`
  font-size: 18px;
  line-height: 24px;
  font-weight: bold;
`
export const Number = styled.div(numberStyles)

export const stringStyles = () => css`
  font-size: 12px;
`
export const String = styled.div(stringStyles)

export const textStyles = () => css`
  text-align: center;
`
export const Text = styled.div(textStyles)
